import React from 'react'
import Box from '@mui/material/Box'
import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { StepBaseProps } from '../types'

export type ConfigureStripeStepProps = StepBaseProps & {
  onConnectOnboarding: () => void
}

export function ConfigureStripeStep(props: ConfigureStripeStepProps) {
  const { isSubmitting = false, onConnectOnboarding } = props

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography>Connect onboarding</Typography>
        <LoadingButton loading={isSubmitting} onClick={onConnectOnboarding} variant="outlined">connect</LoadingButton>
      </Stack>
    </Box>
  )
}

export default ConfigureStripeStep